module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHwAAAB8BAMAAABZMMmNAAAAIVBMVEUAAAC73/91vvrV6/90vvp1vfvE4f/b7v90vfnU6v9ktPcV2coWAAAABnRSTlMA18fMoHzR6Jy9AAAAaUlEQVRYw+3PMQ2AQBAF0bWABRIUfBPUiKDAAKGnwAE5AxSrEgOQWygud8lM/4oxIqLCzfHgcDgcDofD4XA4HA6Hw+Ff+BoPXjnfUkrnf764+9XqeztcUhdJkj03Hvl2e23q8w1GRFS+G1bp9ftfz1gGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/device/icon_xiaofang.png
// module id = 775
// module chunks = 1